import {
  AttackErrorAttribute,
  DetailType,
} from '@collector/sportsapi-client-legacy'

import { DetailConfiguration } from '../../../../composables/useSportOptions'

export enum GroupName {
  ErrorType = 'Error type',
}

export const groups: Map<
  GroupName,
  DetailConfiguration<AttackErrorAttribute>
> = new Map([
  [
    GroupName.ErrorType,
    {
      type: DetailType.Button,
      cols: 2,
      name: GroupName.ErrorType,
      important: true,
      attributes: [
        AttackErrorAttribute.OutAttack,
        AttackErrorAttribute.AntennaAttack,
        AttackErrorAttribute.NetAttack,
        AttackErrorAttribute.IllegalTouch,
      ],
    },
  ],
])
